import { timer } from 'rxjs';
import {
    combineLatest,
    fromEvent,
    merge,
    Observable,
    Subscription,
} from 'rxjs';

import {
    Component,
    Input,
    OnInit,
    HostListener,
    ViewChildren,
    QueryList,
    ElementRef,
    Output,
    EventEmitter,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
    AccountSelectors,
    NavigationSelectors,
    ModulesSelectors,
    AuthorizationActions,
    SosLoaderService,
    LocalizationSelectors,
    CoreSelectors,
} from '@serviceos-ng/core';
import { finalize, map } from 'rxjs/operators';
import {
    collapseOnLeaveAnimation,
    expandOnEnterAnimation,
    fadeInOnEnterAnimation,
    rotateAnimation,
} from 'angular-animations';
import { Router } from '@angular/router';

@Component({
    selector: 'serviceos-web-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
    animations: [
        expandOnEnterAnimation({ duration: 300 }),
        collapseOnLeaveAnimation({ duration: 300 }),
        fadeInOnEnterAnimation({ duration: 300, delay: 0 }),
        rotateAnimation({ duration: 300, degrees: 180 }),
        fadeInOnEnterAnimation({
            anchor: 'menu-wrap-enter',
            duration: 300,
        }),
    ],
})
export class AccountMenuComponent implements OnInit {
    @Select(NavigationSelectors.getNavigation)
    navigation$;

    @Select(AccountSelectors.account)
    account$;

    @Select(ModulesSelectors.getModuleByName('membership'))
    membership$;

    @Select(ModulesSelectors.getModuleConfigText('customer'))
    moduleCustomerTexts$!: Observable<any>;

    accountMenu$: Observable<any>;

    toggleNotification = false;

    toggleMenu = false;

    @Input()
    userPicture = true;

    @Input()
    userNames = true;

    @Output()
    public action = new EventEmitter();
    public isLogoutItemAvailable = false;
    public documentDirection = '';
    public isMembershipEnable;

    // Logic for the arrow to color the same color as first element of dropdown menu items.
    colorArrow = false;
    subscribeChangeInHover: Subscription | null = null;
    @ViewChildren('menuItems', { read: ElementRef })
    set dropdown(element: QueryList<ElementRef>) {
        if (element && element.length) {
            this.subscribeChangeInHover = merge(
                timer(50),
                fromEvent(element?.first?.nativeElement, 'mouseenter'),
                fromEvent(element?.first?.nativeElement, 'mouseleave')
            )
                .pipe(map((event: any) => event.type == 'mouseenter'))
                .subscribe((event) => {
                    if (
                        element?.first?.nativeElement.classList.contains(
                            'active'
                        ) ||
                        event
                    ) {
                        this.colorArrow = true;
                    } else {
                        this.colorArrow = false;
                    }
                });
        } else {
            this.colorArrow = false;
            this.subscribeChangeInHover?.unsubscribe();
        }
    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave(event) {
        this.toggleMenuClick(false);
    }

    constructor(
        private store: Store,
        public sosLoaderService: SosLoaderService,
        public router: Router
    ) {
        this.accountMenu$ = combineLatest([
            this.navigation$,
            this.account$,
            this.membership$,
        ]).pipe(
            map(([navigation, account, membership]: any) => {

                const logoutChecker = navigation.forEach(element => {
                    if(element.name === 'logout') {
                        this.isLogoutItemAvailable = true;
                    }
                });

                let names: string | null = null;
                
                if (account) {
                    names = account?.first_name + ' ' + account?.last_name;
                }

                const navigationItemWithCount = navigation?.find((element) => {
                    return element.count;
                });

                if (navigationItemWithCount) {
                    this.toggleNotification = true;
                } else {
                    this.toggleNotification = false;
                }

                const accountMenu: any = {
                    names: names,
                    avatar: account?.avatar.url,
                    user: account,
                    menu: navigation,
                };

                if (membership) {
                    accountMenu.membership = {
                        not_membership_text: membership?.texts.user_not_member,
                    };
                }

                return accountMenu;
            })
        );
    }

    ngOnInit(): void {
        this.store.select(LocalizationSelectors.getCurrentDirection()).subscribe(
            (currentDirection) => {
                if (currentDirection) {
                    this.documentDirection = currentDirection;
                }
            }
        )

        this.isMembershipEnable = this.store.selectSnapshot(CoreSelectors.isModuleSet('membership'));

    }

    public toggleMenuClick(status?) {
        if (typeof status !== 'undefined') {
            this.toggleMenu = status;
        } else {
            this.toggleMenu = !this.toggleMenu;
        }
    }

    public logout() {
        // const loader = this.sosLoaderService.showLoader();

        this.router.navigate(['/logout']);

        // this.store
        //     .dispatch(new AuthorizationActions.Logout())
        //     .pipe(
        //         finalize(() => {
        //             this.sosLoaderService.hideLoader(loader);
        //             this.router.navigate(['/auth/login']);
        //         })
        //     )
        //     .subscribe();

        // this.store
        //     .dispatch(new AuthorizationActions.Logout())
        //     .pipe(
        //         finalize(() => {
        //             // this.sosLoaderService.hideLoader(loader);
        //             window.location.reload();
        //             // this.router.navigate(['/login']);
        //         })
        //     )
        //     .subscribe();
    }

    public fireAction(action) {
        this.action.emit(action)
    }
}
